import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=e726cc10&scoped=true"
import script from "./CreateStudent.vue?vue&type=script&lang=js"
export * from "./CreateStudent.vue?vue&type=script&lang=js"
import style0 from "./CreateStudent.vue?vue&type=style&index=0&id=e726cc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e726cc10",
  null
  
)

export default component.exports